import { ToastContainer } from "react-toastify";
import Footer from "../Footer/Footer";
import Nav, { NavProps } from "../Nav/Nav";
import styles from "./styles.module.css";

export default function PageScaffold({
  bottomSheet,
  children,
  contrastText,
  hideHomeButton,
  forceNotificationsZero,
  hideLoginButton,
}: {
  bottomSheet?: JSX.Element | JSX.Element[] | null;
  children: React.ReactNode;
} & NavProps) {
  return (
    <div style={{ height: "100%", position: "relative" }}>
      <ToastContainer />
      <Nav
        contrastText={contrastText}
        hideLoginButton={hideLoginButton}
        forceNotificationsZero={forceNotificationsZero}
        hideHomeButton={hideHomeButton}
      />

      <div className={styles["page-container"]}>{children}</div>

      {!bottomSheet && <Footer contrastText={contrastText} />}

      {!!bottomSheet && (
        <div>
          <div className={styles["bottom-sheet-safe-area"]}></div>
          <div className={styles["bottom-sheet"]}>{bottomSheet}</div>
        </div>
      )}
    </div>
  );
}
